export const CSR_SUBNAV = [
    { label: 'Our CSR Eligibility Documents', to: '/csr/eligibility-documents' },
    { label: 'Our CSR Projects', to: '/csr/our-projects' },
    { label: 'Proposal Projects', to: '/csr/proposal-projects' },
    { label: 'Project Proposals', to: '/csr/project-proposals' },
    { label: 'CSR Guidelines (MCA)', to: '/csr/guidelines-mca' },
];

export const MAIN_NAV = [
    { label: 'Home', to: '/' },
    { label: 'About Us', to: '/about' },
    { label: 'Services', to: '/services' },
    { label: 'Sector Achievements', to: '/sector-achievements' },
    // "CSR Projects" is a dropdown (no direct URL). The children drive routing.
    { label: 'CSR Projects', to: '/csr-projects', children: CSR_SUBNAV },
    // The following items are grouped in the "More" dropdown
    { label: 'Success Stories', to: '/success-stories' },
    { label: 'Gallery', to: '/gallery' },
    { label: 'Volunteer Gallery', to: '/volunteer-gallery' },
    { label: 'Media & Awards', to: '/media-awards' },
    { label: 'Downloads', to: '/downloads' },
    { label: 'Donate', to: '/donate' },
    { label: 'Contact Us', to: '/contact' },
];

export const ADMIN_NAV = [
    { label: 'Dashboard', to: '/admin', icon: 'layout-dashboard' },
    // Public content
    { label: 'Site Settings', to: '/admin/settings', icon: 'settings' },
    { label: 'Services', to: '/admin/services', icon: 'briefcase' },
    { label: 'Year-wise Stats', to: '/admin/service-year-stats', icon: 'trending-up' },
    { label: 'Sector Achievements', to: '/admin/sector-achievements', icon: 'trending-up' },
    { label: 'CSR Projects (Ongoing)', to: '/admin/projects', icon: 'package' },
    { label: 'CSR Proposal Projects', to: '/admin/proposal-projects', icon: 'sparkles' },
    { label: 'CSR Project PDFs', to: '/admin/csr-project-pdfs', icon: 'file-text' },
    { label: 'News & Events', to: '/admin/news', icon: 'newspaper' },
    { label: 'Testimonials', to: '/admin/testimonials', icon: 'star' },
    { label: 'Gallery', to: '/admin/gallery', icon: 'camera' },
    { label: 'Gallery Albums', to: '/admin/gallery-albums', icon: 'images' },
    { label: 'Volunteer Albums', to: '/admin/volunteer-albums', icon: 'images' },
    { label: 'Advisors', to: '/admin/advisors', icon: 'users' },
    { label: 'Sectors', to: '/admin/sectors', icon: 'package' },
    { label: 'Partners', to: '/admin/partners', icon: 'handshake' },
    { label: 'Associations', to: '/admin/associations', icon: 'handshake' },
    { label: 'Downloads', to: '/admin/downloads', icon: 'download' },
    { label: 'Impact Stats', to: '/admin/impact-stats', icon: 'trending-up' },
    { label: 'Media & Awards', to: '/admin/media-awards', icon: 'trophy' },
    { label: 'Content Blocks', to: '/admin/content-blocks', icon: 'file-text' },
    // Inbox
    { label: 'Volunteers Inbox', to: '/admin/volunteers', icon: 'inbox' },
    { label: 'Contacts Inbox', to: '/admin/contacts', icon: 'mail' },
    { label: 'Donations Inbox', to: '/admin/donations', icon: 'heart' },
];
